import { baseTheme } from '@src/theme';
import { Alert } from 'antd';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
    & .ant-alert-content {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .ant-alert-message {
            margin: 0;
        }
    }

    #main-icon {
        align-self: flex-start;
    }

    /* Filled types */
    &.filledInfo,
    &.filledSuccess,
    &.filledWarning,
    &.filledDanger {
        #main-icon {
            background-color: rgb(255 255 255 / 0.2);
            color: ${(props) =>
                props.theme?.colors?.secondary?.light?.text ||
                baseTheme.colors.secondary.light.text};
        }

        .ant-alert-message,
        .ant-alert-description,
        .ant-alert-action * {
            color: ${(props) =>
                props.theme?.colors?.secondary?.light?.text ||
                baseTheme.colors.secondary.light.text};
        }
    }

    /* Outlined / default types */
    &.outlined,
    &.info,
    &.success,
    &.warning,
    &.danger {
        .ant-alert-message {
            color: ${(props) =>
                props.theme?.colors?.secondary?.main?.text ||
                baseTheme.colors.secondary.main.text};
        }

        .ant-alert-description {
            color: ${(props) =>
                props.theme?.colors?.secondary?.light?.text ||
                baseTheme.colors.secondary.light.text};
        }

        #main-icon {
            background-color: rgba(0, 0, 0, 0.033);
        }
    }

    /* Specific icon colors */
    &.outlined #main-icon,
    &.info #main-icon {
        color: ${(props) =>
            props.theme?.colors?.info?.main?.icon ||
            baseTheme.colors.info.main.icon};
    }

    &.success #main-icon {
        color: ${(props) =>
            props.theme?.colors?.success?.main?.icon ||
            baseTheme.colors.success.main.icon};
    }

    &.warning #main-icon {
        color: ${(props) =>
            props.theme?.colors?.warning?.main?.icon ||
            baseTheme.colors.warning.main.icon};
    }

    &.danger #main-icon {
        color: ${(props) =>
            props.theme?.colors?.error?.main?.icon ||
            baseTheme.colors.error.main.icon};
    }

    /* Filled backgrounds */
    &.filledInfo {
        background-color: ${(props) =>
            props.theme?.colors?.info?.main?.filled ||
            baseTheme.colors.info.main.filled};
    }

    &.filledSuccess {
        background-color: ${(props) =>
            props.theme?.colors?.success?.main?.filled ||
            baseTheme.colors.success.main.filled};
    }

    &.filledWarning {
        background-color: ${(props) =>
            props.theme?.colors?.warning?.main?.filled ||
            baseTheme.colors.warning.main.filled};
    }

    &.filledDanger {
        background-color: ${(props) =>
            props.theme?.colors?.error?.main?.filled ||
            baseTheme.colors.error.main.filled};
    }

    /* Outlined backgrounds and borders */
    &.outlined,
    &.info {
        background-color: ${(props) =>
            props.theme?.colors?.info?.light?.surfaceBg ||
            baseTheme.colors.info.light.surfaceBg};
        border: 1px solid
            ${(props) =>
                props.theme?.colors?.info?.light?.border ||
                baseTheme.colors.info.light.border};
    }

    &.success {
        background-color: ${(props) =>
            props.theme?.colors?.success?.light?.surfaceBg ||
            baseTheme.colors.success.light.surfaceBg};
        border: 1px solid
            ${(props) =>
                props.theme?.colors?.success?.light?.border ||
                baseTheme.colors.success.light.border};
    }

    &.warning {
        background-color: ${(props) =>
            props.theme?.colors?.warning?.light?.surfaceBg ||
            baseTheme.colors.warning.light.surfaceBg};
        border: 1px solid
            ${(props) =>
                props.theme?.colors?.warning?.light?.border ||
                baseTheme.colors.warning.light.border};
    }

    &.danger {
        background-color: ${(props) =>
            props.theme?.colors?.error?.light?.surfaceBg ||
            baseTheme.colors.error.light.surfaceBg};
        border: 1px solid
            ${(props) =>
                props.theme?.colors?.error?.light?.border ||
                baseTheme.colors.error.light.border};
    }

    /* Typography */
    & .ant-alert-message {
        font-size: 20px;
        line-height: 1.3;
    }

    & .ant-alert-description {
        font-size: 16px;
        line-height: 1.15;
    }
`;
